<template>
  <!-- <Nav /> -->
  <sidenav v-if="showNavbar && !isEmbedded" :custom_class="color" :class="[isRTL ? 'fixed-end' : 'fixed-start']" />    

  <main class="main-content position-relative max-height-vh-100 h-100 ">
    <!-- nav -->
    <!--Nav v-if="showTopNavbar && showNavbar"/-->

    <navbar
      v-if="showNavbar && !isEmbedded"
      :class="[isNavFixed ? navbarFixed : '', isAbsolute ? absolute : '']"
      :color="isAbsolute ? 'text-white opacity-8' : ''"
      :min-nav="navbarMinimize"
    />
    <!-- Loading Overlay -->
    <div v-if="showloading" class="loading-overlay">
      <LoaderIcon />
    </div>
    <!--<LoaderIcon v-if="showloading" />-->
    
    <GlobalAlert
      :message="errorMessage"
      :icon="errorIcon"
      :bgColor="errorBgColor"
      :duration="errorDuration"
      @close="showError = false"
    />
    
    <router-view />
    <!--<app-footer v-show="showFooter" />
    <configurator
      :toggle="toggleConfigurator"
      :class="[showConfig ? 'show' : '', hideConfigButton ? 'd-none' : '']"
    />-->
  </main>  
</template>

<script>

import axios from 'axios';
import LoaderIcon from './components/Loader.vue';
import Sidenav from "./views/Sidenav/index.vue";
//import Configurator from "@/views/Configurator.vue";
//import Nav from "@/views/Navbars/Nav.vue";
import Navbar from "@/views/Navbars/Navbar.vue";
//import AppFooter from "@/views/PageLayout/Footer.vue";
import { mapMutations, mapState } from 'vuex';
import GlobalAlert from '@/components/GlobalAlert.vue'
import emitter from '@/eventBus';
import '@/assets/css/custom-sweetalert.css';

export default {
  name: 'App',
  computed: {
    ...mapState(
      [
        "showloading",
        "isRTL",
        "color",
        "isAbsolute",
        "isNavFixed",
        "navbarFixed",
        "absolute",
        "showSidenav",
        "showNavbar",
        "showFooter",
        "showConfig",
        "hideConfigButton"
      ]),
      isEmbedded() {
        return this.$route.query.embed === 'true';
      },
      showTopNavbar() {
        const routeName = this.$route.name || '';
        const routePath = this.$route.path || '';
        const userRole = this.$store.state.user?.roleName;

        // Hide top navbar for Admin and NotFound page
        return (
          userRole !== 'Admin' &&
          routeName !== 'NotFound' &&
          !routePath.includes('/404') && // optional extra safety
          !routePath.match(/^\/[^/]*$/) // matches the catchAll route if unnamed
        );
      },
      /* {
        showloading: state => state.showloading
      } */
  },
  components: {
    //Nav,
    Sidenav,
    //Configurator,
    Navbar,
    //AppFooter,
    LoaderIcon,
    GlobalAlert,
  },  
  mounted() {
    this.errorHandler = (errorDetails) => {
      console.log('Received trigger-error event:', errorDetails);
      this.triggerError(
        errorDetails.message,
        errorDetails.icon,
        errorDetails.bgColor,
        errorDetails.duration
      );
    };

    emitter.on('trigger-error', this.errorHandler);
  },
  beforeMount() {
    if (this.errorHandler) {
      emitter.off('trigger-error', this.errorHandler);
    }
    //emitter.off('trigger-error', this.errorHandler);

    const sidenav = document.getElementsByClassName("g-sidenav-show")[0];
    if (window.innerWidth > 1200) {
      sidenav.classList.add("g-sidenav-pinned");
    }
  },
  methods: {
    ...mapMutations(["toggleConfigurator", "navbarMinimize"]),
   
    triggerError(message, icon, bgColor, duration) {
      
      this.errorMessage = message;
      this.errorIcon = icon;
      this.errorBgColor = bgColor;

      const defaultDuration = 5000;
      
      if (duration === 'open') {
        this.errorDuration = null;
      } else {
        this.errorDuration = duration ?? defaultDuration;
      }

      this.showError = false;

      this.$nextTick(() => {
        //console.log("Triggering GlobalAlert with:", this.errorMessage);
        this.showError = true;

        if (this.errorDuration !== null) {
          setTimeout(() => {
            this.showError = false;
          }, this.errorDuration);
        }
      });
    }

  },
  data() {
    return {
      showError: false,
      errorMessage: '',
      errorDuration: null,
      errorBgColor: '',
      errorIcon: '',
    };
  },
  async created() {
    if (this.$store.state.isAuthenticated) { // assuming you track authentication in Vuex
      try {
        const response = await axios.get('Auth/user');
        this.$store.dispatch('user', response.data.user || {});        
      } catch (e) {
        this.error = 'Something went wrong!!';
      }
    }    
  }
}
</script>

<style>
.dataTable-pagination-list .active a {
  background-image: linear-gradient(
    195deg,
    #66bb6a 0%,
    #43a047 100%
  ) !important;
}

.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(255, 255, 255, 0.6); /* Semi-transparent white */
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: all; /* Block mouse clicks */
}

.choices__list--dropdown {
  max-height: 250px !important;
  overflow-y: auto !important;
  overflow-x: hidden !important;
}

.choices__inner {
  overflow: visible !important;
}

.choices__input {
  overflow: hidden !important;
}

.choices__list--dropdown .choices__list {
  max-height: none !important;
  overflow: visible !important;
}

/* Optional: Smooth scrollbar */
.choices__list--dropdown::-webkit-scrollbar {
  width: 6px;
}

.choices__list--dropdown::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 4px;
}

.choices[data-type*=select-one].is-open .choices__list--dropdown {
  top: 100% !important;
  bottom: auto !important;
}
</style>